export const patterns = {
  phone: /^\+7\s\(9\d{2}\)\s\d{3}\-\d{2}\-\d{2}$/,
  bonus: /^(\d+)$/,
};

export const masks = {
  phone: ['+','7', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]
};
